/**
 * Licensed Materials - Property of IBM
 * 5737-M66, 5900-AAA, 5900-A0N, 5725-S86, 5737-I75
 * © Copyright IBM Corp. 2020, 2023 All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication, or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
export const EDIT_OTHER_SERVICES_TILES = {
  MAXIMO_TILE: 'maximo-tile',
  FACTORY_TILE: 'factory-tile',
};

export const FACTORY_TALK_DATABASE_SELECTOR = {
  DEFAULT: 'DEFAULT',
  CUSTOM: 'CUSTOM',
};

export const FACTORY_TALK_CUSTOM_DATABASE_TYPES = {
  POSTGRESQL: 'POSTGRESQL',
  DB2: 'DB2',
};

export const DATA_STORAGE = 'Data Storage';

export const CAPACITY_UNITS = {
  mb: 'MB',
  gb: 'GB',
  tb: 'TB',
  millions: 'millions',
  'writes per second': 'writes per second',
};

export const CAPACITY_UNITS_PRECISION = {
  mb: 0,
  millions: 1,
  gb: 1,
  tb: 1,
};

export const TENANT_PLANS = {
  consumer: 'Cloud Consumer Plan',
  enterprise: 'Cloud Enterprise Plan',
  industrial: 'Cloud Industrial Plan',
  sensor: 'Cloud Sensor Type Plan',
};

export const SERVICE_STATUS = {
  active: 'Active',
  inactive: 'Inactive',
  'n/a': 'N/A',
};

export const CONSUMED_STATUS = {
  normal: 1,
  high: 2,
  overage: 3,
};

export const SERVICE_TYPES = {
  MAXIMO_WORK_ORDER: 'MAXIMO_WORK_ORDER',
  FACTORY_TALK: 'FACTORY_TALK',
};

export const BUCKET_RESILIENCY_LOCATION = {
  'Cross Region': ['us', 'eu'],
  Region: ['us-south', 'us-east'],
};

export const BUCKET_STORAGE_CLASS = {
  standard: 'Standard',
  vault: 'Vault',
  cold: 'Cold Vault',
  flex: 'Flex',
};

export const SERVICE_ITEMS = [
  {
    id: 'iotp',
    metrics: [
      {
        name: 'dataExchanged',
        unit: 'mb',
      },
    ],
  },
  {
    id: 'analytic',
    metrics: [
      {
        name: 'millionEvents',
        unit: 'millions',
      },
    ],
  },
  {
    id: 'iot4e',
    dataid: 'IoT4E',
    metrics: [
      {
        name: 'numberOfAppliances',
        unit: null,
      },
    ],
  },
  {
    id: 'cloudant',
    metrics: [
      {
        name: 'dataStorage',
        unit: 'gb',
      },
      {
        name: 'writes',
        unit: 'gb',
      },
    ],
  },
  {
    id: 'dashdb',
    metrics: [
      {
        name: 'dataStorage',
        unit: 'gb',
      },
    ],
  },
  {
    id: 'cos',
    metrics: [
      {
        name: 'dataStorage',
        unit: 'gb',
      },
      {
        name: 'dataRetrieval',
        unit: 'gb',
      },
    ],
  },
  {
    id: 'objectstorage',
    metrics: [
      {
        name: 'dataStorage',
        unit: 'gb',
      },
      {
        name: 'dataOutbound',
        unit: 'gb',
      },
      {
        name: 'dataInbound',
        unit: 'gb',
      },
    ],
  },
  {
    id: 'bos',
    metrics: [
      {
        name: 'dataStorage',
        unit: 'gb',
      },
      {
        name: 'dataRetrieval',
        unit: 'gb',
      },
    ],
  },
  {
    id: 'messagehub',
    metrics: [
      {
        name: 'numberOfMessages',
        unit: null,
      },
      {
        name: 'numberOfPartitions',
        unit: null,
      },
    ],
  },
  {
    id: 'appid',
    metrics: [
      {
        name: 'authorizedUsers',
        unit: null,
      },
      {
        name: 'authenticationEvents',
        unit: null,
      },
    ],
  },
  {
    id: 'securegateway',
    metrics: [
      {
        name: 'numberOfGateways',
        unit: null,
      },
      {
        name: 'dataTransmitted',
        unit: 'gb',
      },
    ],
  },
  {
    id: 'iotbc',
    metrics: [
      {
        name: 'numberOfBCMessages',
        unit: null,
      },
    ],
  },
  {
    id: 'iotih',
    metrics: [
      {
        name: 'numberOfHomes',
        unit: null,
      },
    ],
  },
  {
    id: 'iotiw',
    metrics: [
      {
        name: 'numberOfWorkers',
        unit: null,
      },
    ],
  },
  {
    id: 'postgresql',
    metrics: [
      {
        name: 'disk',
        unit: 'gb',
      },
      {
        name: 'memory',
        unit: 'gb',
      },
    ],
  },
];

export const CREDENTIALS = 'Credentials';
export const BUCKETS = 'Buckets';

export const DIMENSION_TYPE = {
  DB_TABLE: 'DB_TABLE',
  DB_TAG_TABLE: 'DB_TAG_TABLE',
  FILE_CSV: 'FILE_CSV',
  UI: 'UI',
};

export const STANDARD_DIMENSIONS = [
  {
    name: 'Tagname',
    source: DIMENSION_TYPE.DB_TAG_TABLE,
  },
  {
    name: 'Tagtype',
    source: DIMENSION_TYPE.DB_TAG_TABLE,
  },
  {
    name: 'Tagdatatype',
    source: DIMENSION_TYPE.DB_TAG_TABLE,
  },
];

export const FILTER_TYPES = {
  TAGS_AS_ENTITIES: 'TAGS_AS_ENTITIES',
  TAGS_AS_ENTITIES_FILTER: 'TAGS_AS_ENTITIES_FILTER',
};

export const ENTITY_STATUS = {
  CREATE: 'CREATE',
  UPDATE: 'UPDATE',
  DELETE: 'DELETE',
};

export const TAG_DATA_TYPES = {
  NUMBER: 'NUMBER',
  INTEGER: 'INTEGER',
  LONG: 'LONG',
  FLOAT: 'FLOAT',
  STRING: 'STRING',
  ALARM: 'ALARM',
};
